<div class="product-editor">
    <div
        *ngIf="!itemsArray || itemsArray.length === 0"
        class="text-center py-4 text-gray-500"
    >
        Loading products...
    </div>

    <form [formGroup]="orderForm" *ngIf="itemsArray && itemsArray.length > 0">
        <!-- Products Table -->
        <div formArrayName="items">
            <nz-table
                #itemsTable
                [nzData]="itemsArray.controls"
                [nzShowPagination]="itemsArray.controls.length > 10"
                nzPaginationType="small"
                nzSize="small"
                [nzNoResult]="'No Products'"
            >
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Options</th>
                        <th>Listed Price</th>
                        <th>Sale Price</th>
                        <th>Qty</th>
                        <th>Drug Price</th>
                        <th>Total Discount</th>
                        <th>Total Insurance</th>
                        <th>Total Amount</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        *ngFor="let formGroup of itemsArray.controls; let i = index"
                        [formGroupName]="i"
                    >
                        <!-- Product info -->
                        <td>
                            <div class="font-medium">
                                {{ products[i]?.name }}
                            </div>
                            <div class="text-xs text-gray-500">
                                {{ products[i]?.subLabel }}
                            </div>
                            <div class="text-xs text-gray-500">
                                {{ products[i]?.productId }}
                            </div>
                        </td>

                        <!-- Options -->
                        <td>
                            <div class="flex flex-wrap gap-1 justify-center">
                                <nz-tag
                                    *ngFor="let option of products[i]?.options | keyvalue"
                                >
                                    {{ option.key }}: {{ option.value }}
                                </nz-tag>
                            </div>
                        </td>

                        <!-- Listed Price (read-only) -->
                        <td>
                            {{ products[i]?.listPrice || products[i]?.price || 0
                            | currency }}
                        </td>

                        <!-- Sale Price (editable) -->
                        <td>
                            <div class="flex flex-col">
                                <nz-input-number
                                    formControlName="salePrice"
                                    (input)="onDecimalInput($event, i, 'salePrice')"
                                    [nzMin]="0"
                                    [nzStep]="0.01"
                                    [nzStatus]="hasFieldError(i, 'salePrice') ? 'error' : ''"
                                />
                                <div
                                    *ngIf="hasFieldError(i, 'salePrice')"
                                    class="text-red-500 text-xs mt-1"
                                >
                                    {{ getFieldError(i, 'salePrice') }}
                                </div>
                            </div>
                        </td>

                        <!-- Quantity (editable) -->
                        <td>
                            <div class="flex flex-col">
                                <nz-input-number
                                    formControlName="quantity"
                                    [nzMin]="1"
                                    [nzStatus]="hasFieldError(i, 'quantity') ? 'error' : ''"
                                />
                                <div
                                    *ngIf="hasFieldError(i, 'quantity')"
                                    class="text-red-500 text-xs mt-1"
                                >
                                    {{ getFieldError(i, 'quantity') }}
                                </div>
                            </div>
                        </td>

                        <!-- Drug Price (editable) -->
                        <td>
                            <div class="flex flex-col">
                                <nz-input-number
                                    formControlName="drugPrice"
                                    (input)="onDecimalInput($event, i, 'drugPrice')"
                                    [nzMin]="0"
                                    [nzStep]="0.01"
                                    [nzStatus]="hasFieldError(i, 'drugPrice') ? 'error' : ''"
                                />
                                <div
                                    *ngIf="hasFieldError(i, 'drugPrice')"
                                    class="text-red-500 text-xs mt-1"
                                >
                                    {{ getFieldError(i, 'drugPrice') }}
                                </div>
                            </div>
                        </td>

                        <!-- Discount (editable) -->
                        <td>
                            <div class="flex flex-col">
                                <nz-input-number
                                    formControlName="discount"
                                    (input)="onDecimalInput($event, i, 'discount')"
                                    [nzMin]="0"
                                    [nzStep]="0.01"
                                    [nzStatus]="hasFieldError(i, 'discount') ? 'error' : ''"
                                    [nzDisabled]="!allowDiscountEdit()"
                                    [nzTooltipTitle]="!allowDiscountEdit() ? 'Discount cannot be edited as a coupon or promotion is applied' : ''"
                                    nz-tooltip
                                />
                                <div
                                    *ngIf="hasFieldError(i, 'discount')"
                                    class="text-red-500 text-xs mt-1"
                                >
                                    {{ getFieldError(i, 'discount') }}
                                </div>
                            </div>
                        </td>

                        <!-- Insurance (editable) -->
                        <td>
                            <div
                                formArrayName="insuranceCoverages"
                                class="flex flex-col flex-wrap gap-1 items-center justify-center"
                            >
                                <div class="text-xs text-gray-500 mb-1">
                                    Total: {{
                                    getTotalInsuranceAmount(formGroup.value) |
                                    currency }}
                                </div>

                                <div
                                    *ngFor="let insuranceGroup of getInsuranceArray(i).controls; let insuranceIndex = index"
                                    [formGroupName]="insuranceIndex"
                                    class="inline-flex items-center gap-1.5 mb-1 rounded px-1 py-0.5"
                                >
                                    <nz-select
                                        formControlName="type"
                                        nzPlaceHolder="Select Insurance"
                                    >
                                        <nz-option
                                            *ngFor="let type of insuranceTypes"
                                            [nzValue]="type.key"
                                            [nzLabel]="type.label"
                                        ></nz-option>
                                    </nz-select>
                                    <div class="flex flex-col">
                                        <nz-input-number
                                            formControlName="amount"
                                            (input)="onDecimalInput($event, i, 'insurance')"
                                            [nzMin]="0"
                                            placeholder="Amount"
                                            [nzStep]="0.01"
                                            [nzStatus]="hasFieldError(i, 'amount') ? 'error' : ''"
                                        />
                                        <div
                                            *ngIf="hasFieldError(i, 'amount')"
                                            class="text-red-500 text-xs mt-1"
                                        >
                                            {{ getFieldError(i, 'amount') }}
                                        </div>
                                    </div>
                                    <button
                                        nz-button
                                        nzType="text"
                                        (click)="removeInsurance(i, insuranceIndex)"
                                        class="p-0 h-[22px] w-[22px] min-w-[22px] bg-transparent border-0 flex items-center justify-center"
                                    >
                                        <i class="fa-solid fa-x"></i>
                                    </button>
                                </div>

                                <button
                                    nz-button
                                    nzType="dashed"
                                    (click)="addInsurance(i)"
                                    class="add-insurance-btn"
                                >
                                    <i class="fa-solid fa-plus mr-2"></i>
                                    Add Insurance
                                </button>
                                <div
                                    class="text-red-500 text-xs mt-1"
                                    *ngIf="isInsuranceMaxed(i)"
                                >
                                    Total insurance coverage cannot exceed the
                                    drug price
                                </div>
                            </div>
                        </td>

                        <!-- Total Amount -->
                        <td>{{ calculateProductTotal(i) | currency }}</td>
                    </tr>
                </tbody>
            </nz-table>
        </div>
    </form>
</div>
